import { FC } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ReactTimeAgo from "react-time-ago";
import { faCodeBranch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Group, Stack, Text } from "@mantine/core";

import { Issue } from "@protos/issues/v1/issues";
import { validateUrl } from "@shared/utils";

import { formatGitProvider, getGitProviderLinks } from "../../../utils";

dayjs.extend(utc);
export interface FirstSeenActivityProps {
  finding: Issue;
}

export const FirstSeenActivity: FC<FirstSeenActivityProps> = ({ finding }) => {
  const { ref, refUrl, provider } = getGitProviderLinks(finding);
  const dateStr = finding.createdAt
    ? dayjs.utc(finding.createdAt).format("ddd, D MMM YYYY HH:mm:ss") // this matches the old format exactly and is easy to change if necessary
    : null;
  const author = finding.firstSeenScan?.meta?.commit_author_username;

  return (
    <Stack gap={4}>
      <Group gap={8} fz="sm">
        <FontAwesomeIcon
          icon={faCodeBranch}
          style={{ color: "var(--mantine-color-gray-7)" }}
        />
        {refUrl === undefined ? (
          <Text inherit c="gray">
            {ref}
          </Text>
        ) : (
          <Anchor
            href={validateUrl(refUrl)}
            inherit
            c="gray.7"
            target="_blank"
            rel="noopener noreferrer"
          >
            {ref}
          </Anchor>
        )}
      </Group>
      <Text c="gray" size="sm">
        {dateStr}
      </Text>
      <Text c="dimmed" size="xs">
        {finding.createdAt && (
          <ReactTimeAgo date={finding.createdAt} locale="en-US" />
        )}
        {author && ` by ${author}`}
        {provider && ` via ${formatGitProvider(provider)}`}
      </Text>
    </Stack>
  );
};
